import { DEFAULT_AXIS_CONFIG, DEFAULT_AXIS_TYPE } from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import VisualizationConfig from "./VisualizationConfig";
export const DEFAULT_BARMODE = "group";
export default class BarVisualizationConfig extends VisualizationConfig {
  constructor(barmode, axisType, axisConfig = DEFAULT_AXIS_CONFIG) {
    super();
    this._value = { barmode, axisType, axisConfig };
  }
  get barmode() {
    return this._value.barmode;
  }
  get axisType() {
    return this._value.axisType;
  }
  get opacity() {
    return this.barmode === "overlay" ? 0.75 : 1;
  }
  get axisConfig() {
    return this._value.axisConfig;
  }
  toBuilder() {
    const { barmode, axisType, axisConfig } = this._value;
    return new Builder({ barmode, axisType, axisConfig });
  }
  static create(barmode, axisType = DEFAULT_AXIS_TYPE, axisConfig = DEFAULT_AXIS_CONFIG) {
    return new BarVisualizationConfig(barmode, axisType, axisConfig);
  }
  static empty() {
    return BarVisualizationConfig.create(DEFAULT_BARMODE);
  }
  toJSON() {
    const { barmode, axisType, axisConfig } = this._value;
    return {
      barmode,
      axis_type: axisType,
      axis_config: axisConfig
    };
  }
  static fromJSON(_type, value) {
    const { barmode, axis_type, axis_config } = value;
    return BarVisualizationConfig.create(barmode, axis_type, axis_config);
  }
}
class Builder {
  constructor(value) {
    this.value = Object.freeze({ ...value });
  }
  barmode(value) {
    return new Builder({ ...this.value, barmode: value });
  }
  axisType(value) {
    return new Builder({ ...this.value, axisType: value });
  }
  axisConfig(value) {
    return new Builder({ ...this.value, axisConfig: value });
  }
  build() {
    const { barmode, axisType } = this.value;
    return new BarVisualizationConfig(barmode, axisType);
  }
}
